import { baseToApiShape, baseFromApiShape, baseInitNewForm, baseInitEditForm } from '../formHelpers/base';

/**
 * IBM has no provider-specific fields beyond the shared base.
 * These thin wrappers maintain the per-provider API contract.
 */

export function toApiShape(form) {
    const base = baseToApiShape(form);
    return {
        ...base,
        data: {
            ...base.data,
            network: {
                ...base.data.network,
                capacity_reservation_parallel_deployment: form.capacityReservationParallelDeployment ?? false,
            },
        },
    };
}

export function fromApiShape(cluster) {
    return {
        ...baseFromApiShape(cluster),
        capacityReservationParallelDeployment: cluster.data?.network?.capacity_reservation_parallel_deployment ?? false,
    };
}

export function initNewForm(provider, config) {
    return {
        ...baseInitNewForm(provider, config),
        capacityReservationParallelDeployment: config.clusterSettings?.fastCapacityValidationDefault === true,
    };
}

export function initEditForm(cluster, config) {
    return {
        ...baseInitEditForm(cluster, config),
        capacityReservationParallelDeployment: cluster.data?.network?.capacity_reservation_parallel_deployment ?? false,
    };
}
